module.exports = __webpack_public_path__ + "img/ios_seminar_at_bracu.15ab24ee.png";